import zalandoLogo from '../Assets/zalando.jpg';
import adidasLogo from '../Assets/adidas.jpg';
import infosysLogo from '../Assets/infosys.jpg';
import lemonOneLogo from '../Assets/lemonOne.jpg';

export const ExperienceData = [
  {
    company: "Zalando SE",
    duration: "Aug 2020 – Present",
    location: "Berlin, Germany",
    role: "Senior Specialist (AI & Automation)",
    logo: zalandoLogo,
    experience: [
      "Architected multi-agent systems using **LangGraph** and **Google ADK**, implementing stateful workflows with **Pydantic** for rigorous runtime data validation, and drove cross-departmental AI rollout from design through production.",
      "Designed production **AI Harnesses** with built-in guardrails, human-in-the-loop safety layers, and observability pipelines \u2014 the work that makes autonomous agents trustworthy at enterprise scale.",
      "Built **TARS**, an A2A-protocol-compatible agentic CRM combining multi-agent orchestration with Salesforce for autonomous CRM workflows and intelligent lead management.",
      "Integrated **HuggingFace Transformers** for domain-specific NLP; cut inference cost via **KV caching** and reduced training compute by **60%** through **LoRA** fine-tuning on **AWS Bedrock**.",
      "Built a hybrid-cloud **Retrieval-Augmented Generation (RAG)** system across **AWS Bedrock** and **Google Cloud Platform** for enterprise knowledge retrieval.",
      "Led end-to-end deployment of **Salesforce Agentforce** and engineered **n8n + Model Context Protocol (MCP)** integrations enabling intelligent context exchange between enterprise platforms.",
      "Shipped a production **Jira\u2013Salesforce webhook middleware** service \u2014 bidirectional sync, event-driven architecture, real-time exchange between ticketing and CRM.",
      "Managed **Salesforce DX** CI/CD pipelines (Gearset) for continuous agent configuration deployment."
    ]
  },
  {
    company: "LemonOne SE",
    duration: "Feb 2020 – Jul 2020",
    location: "Berlin, Germany",
    role: "Senior Technical Specialist",
    logo: lemonOneLogo,
    experience: [
      "Developed and maintained full-stack applications using the **MERN stack** (MongoDB, Express, React, Node.js).",
      "Led system integrations across disparate platforms.",
      "Specialized in **Salesforce DX (SFDX)** based development, providing expert consultancy and optimizing development workflows.",
      "Orchestrated and managed **CI/CD pipelines** to automate deployment processes and ensure high code quality."
    ]
  },
  {
    company: "adidas AG",
    duration: "Mar 2017 – Jan 2020",
    location: "Herzogenaurach, Germany",
    role: "External Technology Specialist",
    logo: adidasLogo,
    experience: [
      "Served as the lead architect for **Salesforce Service Cloud**, delivering omnichannel support solutions (Chat, WhatsApp, Social Media) for global customer service operations.",
      "Transformed global campaign management by building a custom **Salesforce Lightning portal**, replacing legacy spreadsheet-based workflows with a fully automated tracking system.",
      "Built and maintained **CI/CD pipelines** with Jenkins and Gearset across a multi-sandbox Salesforce estate."
    ]
  },
  {
    company: "Infosys",
    duration: "Jan 2015 – Feb 2017",
    location: "Mysuru, India",
    role: "Senior Systems Engineer",
    logo: infosysLogo,
    experience: [
      "Delivered enterprise **CRM implementations**: custom **Apex/Visualforce**, plus third-party system integration."
    ]
  }
];